import { defineStore } from 'pinia'

export const useLnsProgramStore = defineStore('lnsProgram', {
  state: () => ({
    showMobileLoyaltyProgram: false,
    history: [],
  }),
  getters: {
    lnsHistory: (state) => state.history || [],
  },
  actions: {
    setShowMobileLoyaltyProgram(show) {
      this.showMobileLoyaltyProgram = !!show
    },
  },
})
